<template>
  <div>
    <z-card
      v-if="collectorStep === 'infoForm'"
    >
      <z-title
        align="left"
        class="lead-collector-section__title"
        size="small"
        weight="medium"
      >
        {{ $t('title') }}
      </z-title>
      <QForm
        class="lead-collector-form__body"
        @submit="onSubmit"
      >
        <z-input-field
          v-slot="{ valid }"
          error-message="Por favor, informe seu nome"
          label="Nome"
          rules="required"
          class="lead-collector-form__input-wrapper"
        >
          <z-input
            v-model="leadName"
            class="lead-collector-form__input"
            :valid="valid"
            :placeholder="$t('placeholders.name')"
            type="text"
          />
        </z-input-field>

        <z-input-field
          v-slot="{ valid }"
          error-message="Por favor, informe seu e-mail"
          label="E-mail"
          rules="required|email"
          class="lead-collector-form__input-wrapper"
        >
          <z-input
            v-model="leadEmail"
            class="lead-collector-form__input"
            :valid="valid"
            :placeholder="$t('placeholders.email')"
            type="email"
          />
        </z-input-field>

        <z-input-field
          v-slot="{ valid }"
          error-message="Por favor, informe seu telefone"
          label="Telefone"
          rules="required|phone_number"
          class="lead-collector-form__input-wrapper"
        >
          <z-input
            v-model="leadPhone"
            v-maska
            data-maska="(##) #####-####"
            class="lead-collector-form__input"
            :valid="valid"
            :placeholder="$t('placeholders.phone')"
            type="tel"
          />
        </z-input-field>

        <z-button
          class="lead-collector-form__info-form-button"
        >
          {{ $t('submit') }}
        </z-button>
      </QForm>
    </z-card>
    <LeadCollectorSuccess
      v-else
      orientation="vertical"
    />
  </div>
</template>

<script>
import { vMaska } from 'maska'
import LeadCollectorSuccess from '../lead-collector/lead-collector-success.vue'
import messages from './i18n/lead-collector.json'
import { sendTrackingEvent } from '~/assets/js/services/event-tracker'
import { trackMontillaLead } from '~/assets/js/services/montilla-lead-tracker'
import QForm from '~/components/q-form.vue'

export default {
  name: 'LessonLeadCollector',
  components: {
    QForm,
    LeadCollectorSuccess,
  },
  directives: {
    maska: vMaska,
  },
  props: {
    source: {
      type: String,
      required: true,
    },
    customEventAttributes: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data () {
    return {
      collectorStep: 'infoForm',
      leadName: '',
      leadEmail: '',
      leadPhone: '',
    }
  },
  methods: {
    onSubmit ({ valid }) {
      if (!valid) return

      this.collectorStep = 'success'

      const leadPayload = {
        name: this.leadName,
        email: this.leadEmail,
        phone: this.leadPhone,
        origin: this.source,
        ...this.customEventAttributes,
      }

      sendTrackingEvent('lead', leadPayload)

      trackMontillaLead({
        componentName: 'lesson_lead_collector',
        informationType: 'user',
        eventData: leadPayload,
      })

      this.$emit('submit')
    },
  },
  i18n: {
    messages: {
      'pt-BR': messages,
    },
  },
}
</script>

<style lang="scss" scoped>
.lead-collector-form__body {
  display: flex;
  flex-direction: column;
  gap: var(--unit-0400);
}

.lead-collector-form__info-form-button {
  width: 100%;
  border-radius: var(--unit-0200);
}

.lead-collector-section__title {
  margin-bottom: var(--unit-0600);
}

.lead-collector-form__info-form-phone {
  margin-bottom: 0;
}

.lead-collector-form__info-form-button {
  margin-top: var(--unit-0400);
}

.lead-collector-form__input-wrapper {
  margin-bottom: 0;
}

.lead-collector-form__input {
  border-radius: var(--unit-0200);
}
</style>
